export enum PositionState {
  Open = 'OPEN',
  Closed = 'CLOSED',
  Halted = 'HALTED',
}
